import { render, staticRenderFns } from "./TipTapEditor.vue?vue&type=template&id=5b3ca678&scoped=true&"
import script from "./TipTapEditor.vue?vue&type=script&lang=js&"
export * from "./TipTapEditor.vue?vue&type=script&lang=js&"
import style0 from "./TipTapEditor.vue?vue&type=style&index=0&id=5b3ca678&scoped=true&lang=css&"
import style1 from "./TipTapEditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3ca678",
  null
  
)

export default component.exports